/* global axios */
import ApiClient from '../ApiClient';

class CaptainUsage extends ApiClient {
  constructor() {
    super('captain/usage', { accountScoped: true });
  }

  get({ from, to } = {}) {
    return axios.get(this.url, { params: { from, to } });
  }
}

export default new CaptainUsage();
